import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      isAuthenticated : true,
      accountId : "3680542000000055103"
  },
  mutations: {},
  actions: {
      setAuthState(accountId){
          this.state.isAuthenticated = true;
          this.state.accountId = accountId;
      },
      clearAuthState(){
        this.state.isAuthenticated = false;
        this.state.accountId = null;
      }
  },
  modules: {},
});
